import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NormalTable from "./NormalTable";
import { commonCss } from "../StyleConfig/CommonCss";

const AuditLogDialog = ({ open, onClose, data, columns }) => {
  return (
    <Dialog
      maxWidth={"md"}
      fullWidth
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: "white",
          borderRadius: "10px",
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: "rgb(0, 86, 151)", fontWeight: "bold" }}
          >
            Form Reassignment Audit Logs
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ p: 2 }}>
          {data && data.length > 0 ? (
            <NormalTable columns={columns} data={data} paginationProps={true} />
          ) : (
            <Typography>No audit logs available</Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AuditLogDialog;
